export default {"src":"/_next/static/media/arrow-right-white.d888bf61.svg","height":22,"width":12,"blurWidth":0,"blurHeight":0};